/*
* Association location form view for authenticated users
*/

import * as React from 'react';
import * as _ from 'lodash';
// import { Row } from 'react-bootstrap';

import * as DetailFormCommon from './common';
import * as KendoWrappers from '../../common/kendoforms/componentwrappers';
// import { BootstrapColXl as Col } from '../../common/bootstrap/bootstrapcolxl';

export const ClientDetailsLocation = ({
    appText,
    handleFormInputChange,    
    handleSubmitForm,
    handleSaveChanges,
    numFormChanges,    
    formData,
    defaultInputProps,
    sectionTitle,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    let inputPropsFullWidth = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
        // handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
    }); 

    let inputPropsFullWidthTextDebounced = _.merge({}, defaultInputProps, {
        // onChange: (n, v) => { handleFormInputChange(n, v); },
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
    });

    let inputProps = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
    });

    let inputPropsFullWidthOwnRow = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
        colLabelXs: 12,
        colInputXs: 12,
    });

    let inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
        // onChange: (o) => { handleFormInputChange({target: { type: 'virtualized-select' }}, o); }
    });

    return (
        <DetailFormCommon.ClientDetailFormSection title={sectionTitle}>
            <div>               
                <div>
                    <KendoWrappers.KendoTextInputDebounced
                        name="name"
                        label={appText('client-name')}
                        value={formData.name}
                        {...inputPropsFullWidthTextDebounced}
                    />
                </div>

                <DetailFormCommon.ClientDetailFormSectionSpacing />

                <div>
                    <KendoWrappers.KendoTextInputDebounced
                        name="location.address1"
                        label={appText('address')}
                        value={formData.location.address1}
                        {...inputPropsFullWidthTextDebounced}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoTextInputDebounced
                        name="location.address2"
                        label={appText('address2')}
                        value={formData.location.address2}
                        {...inputPropsFullWidthTextDebounced}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoTextInputDebounced
                        name="location.city"
                        label={appText('city')}
                        value={formData.location.city}
                        {...inputPropsFullWidthTextDebounced}
                    />
                </div>
               
                <div>
                    <KendoWrappers.KendoVirtualizedSelectInput
                        name="location.stateCode"
                        label={appText('state')}
                        labelKey="text"
                        valueKey="value"
                        value={formData.location.stateCode}
                        options={formData.options.states}                        
                        onChange={(o) => { handleFormInputChange({target: { name: 'location.stateCode', type: 'virtualized-select' }}, o); }}
                        {...inputPropsVirtualizedSelect}                        
                    />
                </div>

                  <div>
                    <KendoWrappers.KendoVirtualizedSelectInput
                        name="location.countryCode"
                        label={appText('country')}
                        labelKey="text"
                        valueKey="value"
                        value={formData.location.countryCode}
                        options={formData.options.countries}                        
                        onChange={(o) => { handleFormInputChange({target: { name: 'location.countryCode', type: 'virtualized-select' }}, o); }}
                        {...inputPropsVirtualizedSelect}                        
                    />
                </div>

                <div>
                    <KendoWrappers.KendoTextInputDebounced
                        name="location.postalCode"
                        label={appText('zip')}
                        value={formData.location.postalCode}
                        {...inputPropsFullWidthTextDebounced}
                    />
                </div>
            </div>
        </DetailFormCommon.ClientDetailFormSection>
    );
};



// WEBPACK FOOTER //
// ./src/client/detail-form/client-details-location.tsx